exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4a7fc860] .el-upload{width:100%!important}.uploadDoc[data-v-4a7fc860] .el-upload-dragger{width:100%!important;height:230px!important}", ""]);

// exports
